import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class HomepageFeatureService {
    private _router = inject(Router);

    goToFeature() {
        this._router.navigate(['/', 'homepage']);
    }
}
